import qs from 'qs';

const YOUTUBEMATCH_URL =
    /^https?:\/\/(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
const VIMEOMATCH_URL =
    /^https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;  

const YOUTUBE_PREFIX = 'https://www.youtube.com/embed/';
const VIMEO_PREFIX = 'https://player.vimeo.com/video/';

function isYoutube(url: string) {
    return YOUTUBEMATCH_URL.test(url);
}

function isVimeo(url: string) {
    return VIMEOMATCH_URL.test(url);
}

function getYoutubeSrc(url: string, locale?: string) {
    const [, id] = url.match(YOUTUBEMATCH_URL) ?? [];

    const query = qs.stringify({
        autoplay: 1,
        modestbranding: 1,
        hl: locale ?? undefined,
    });

    return {
        type: 'iframe',
        url: `${YOUTUBE_PREFIX}${id}?${query}`,
    };
}

function getVimeoSrc(url: string) {
    const [, , , id] = url.match(VIMEOMATCH_URL) ?? [];

    const query = qs.stringify({
        autoplay: 1,
        byline: 0,
        transparent: 1,
    });

    return {
        type: 'iframe',
        url: `${VIMEO_PREFIX}${id}?${query}`,
    };
}

export const getVideoSrc = (url: string, locale?: string) => {
    if (isYoutube(url)) {
        return getYoutubeSrc(url, locale);
    }

    if (isVimeo(url)) {
        return getVimeoSrc(url);
    }

    return {
        type: 'video',
        url,
    };
};

type StoryVideoPlayerProps = {
    locale?: string;
    url: string;
};

export function StoryVideoPlayer({
    locale,
    url: urlProp,
}: StoryVideoPlayerProps) {
    const { type, url } = getVideoSrc(urlProp, locale);

    if (type === 'iframe') {
        return (
            <iframe
                className="absolute inset-0 h-full w-full bg-black"
                src={url}
                title={url}
                frameBorder={0}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        );
    }

    return <video className="h-full w-full bg-black" src={url} />;
}
